export const CERTIFICATION_CREATED_REQUESTED = 'CERTIFICATION_CREATED_REQUESTED';
export const CERTIFICATION_CREATED_SUCCEED = 'CERTIFICATION_CREATED_SUCCEED';
export const CERTIFICATION_CREATED_FAILED = 'CERTIFICATION_CREATED_FAILED';

export const CERTIFICATIONS_RETRIEVE_REQUESTED = 'CERTIFICATIONS_RETRIEVE_REQUESTED';
export const CERTIFICATIONS_RETRIEVE_SUCCEED = 'CERTIFICATIONS_RETRIEVE_SUCCEED';
export const CERTIFICATIONS_RETRIEVE_FAILED = 'CERTIFICATIONS_RETRIEVE_FAILED';

export const CERTIFICATION_VOID_REQUESTED = 'CERTIFICATION_VOID_REQUESTED';
export const CERTIFICATION_VOID_SUCCEED = 'CERTIFICATION_VOID_SUCCEED';
export const CERTIFICATION_VOID_FAILED = 'CERTIFICATION_VOID_FAILED';

export const CERTIFICATION_GET_LATEST_REQUESTED = 'CERTIFICATION_GET_LATEST_REQUESTED';
export const CERTIFICATION_GET_LATEST_SUCCEED = 'CERTIFICATION_GET_LATEST_SUCCEED';
export const CERTIFICATION_GET_LATEST_FAILED = 'CERTIFICATION_GET_LATEST_FAILED';

export const CERTIFICATION_CONSULT_GET_LATEST_REQUESTED =
  'CERTIFICATION_CONSULT_GET_LATEST_REQUESTED';
export const CERTIFICATION_CONSULT_GET_LATEST_SUCCEED = 'CERTIFICATION_CONSULT_GET_LATEST_SUCCEED';
export const CERTIFICATION_CONSULT_GET_LATEST_FAILED = 'CERTIFICATION_CONSULT_GET_LATEST_FAILED';

export const CERTIFICATION_GET_DETAIL_REQUESTED = 'CERTIFICATION_GET_DETAIL_REQUESTED';
export const CERTIFICATION_GET_DETAIL_SUCCEED = 'CERTIFICATION_GET_DETAIL_SUCCEED';
export const CERTIFICATION_GET_DETAIL_FAILED = 'CERTIFICATION_GET_DETAIL_FAILED';

export const CERTIFICATION_RESET_STATE = 'CERTIFICATION_RESET_STATE';
